import React from 'react'
 //commented for coming soon till images are created for these sections
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import { Autoplay, Pagination} from 'swiper/modules';

const ServiceGallery = (props) => {
  return (
    //coming soon till images are created for these sections
    // <>
    //      <div className="service-gallery-slider swiper-container">
    //             <Swiper
    //     slidesPerView={5}
    //             spaceBetween={30}
    //             loop={true}
    //                autoplay={{
    //              delay: 4000,
    //              disableOnInteraction: false,
    //                    }}
    //              roundLengths={true}     
    //              modules={[Autoplay, Pagination]}                     
    //              speed={400}
    //              pagination={{
    //                 clickable: true,
    //                 el: ".swiper-pagination",
    //               }}
    //              breakpoints={{
    //               1600: { slidesPerView: 5 },
    //              1200: { slidesPerView: 4, spaceBetween: 50 },
    //               992: { slidesPerView: 3, spaceBetween: 40 },
    //              768: { slidesPerView: 2, spaceBetween: 30 },
    //              576: { slidesPerView: 2, spaceBetween: 30 },
    //              0: { slidesPerView: 1 },
    //             }}        
    //             className="swiper-wrapper">
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img1} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img2} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img3} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img4} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img5} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //                 <SwiperSlide className="swiper-slide">
    //                     <div className="xb-item--image">
    //                         <img src={props.img6} alt=""/>
    //                     </div>
    //                 </SwiperSlide>
    //             </Swiper>
    //             <div className="swiper-pagination" style={{position: "static"}}></div>
    //         </div>
           
    // </>
    " "
  )
}

export default ServiceGallery
